// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"videoEmbed-module--videoEmbed--fYhiH"};